const french = {
    navbar: {
      about: 'À propos',
      contact: 'Contact',
      help: 'helpo'
    },
    hero: {
      title: 'Bienvenue sur notre site Web',
      subtitle: 'Nous sommes heureux de vous avoir ici'
    },
    footer: {
      address: '123 Rue Principale, Uneville, France',
      phone: 'Appelez-nous: (123) 456-7890',
      email: 'Envoyez-nous un email: info@exemple.com'
    }
  };
  
  export default french;
  